import React from 'react';

function CenterContent({ children, style, horizontal, inline, wrap = false, ...props }) {
  return (
    <div style={{ display: inline ? 'inline-flex' : 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: horizontal ? 'row' : 'column', gap: 8, flexWrap: wrap ? 'wrap' : 'nowrap', ...style }} {...props}>
      {children}
    </div>
  );
}
export default CenterContent;
